import {
    queryGroupOptions,
    queryAccountData,
    deleteAccountData,
    queryRoleOptions,
    updateAccountStatus,
    queryGroupData,
    deleteGroupData,
    updateGroupStatus,
    queryRoleData,
    deleteRoleData,
    updateRoleStatus,
    getTagTreesData
} from "@/views/zhiji/js/services/service.js";

import { sceneTree2Selector } from "@/views/zhiji/js/common/util.js";

// eslint-disable-next-line
export default {
    state: {
        accountData: [],
        accountTotal: 0,
        groupOption: [],
        querySetting: {
            page: 1
        },
        roleOption: [],
        groupData: [],
        groupListTotal: 0,
        roleData: [],
        roleListTotal: 0,
        groupTagDatas: [],
        searchGroupTagDatas: []
    },
    mutations: {
        updateGroupOption(state, options) {
            state.groupOption.push(...options);
        },
        clearGroupOption(state) {
            state.groupOption.splice(0);
        },
        updateRoleOption(state, options) {
            state.roleOption.push(...options);
        },
        clearRoleOption(state) {
            state.roleOption.splice(0);
        },
        updateParamSetting(state, setting = {}) {
            state.querySetting = Object.assign({}, state.querySetting, setting);
        },
        updateAccountList(state, tableData) {
            state.accountData.splice(0, state.accountData.length, ...tableData.accountData);
            state.accountTotal = tableData.accountTotal;
        },
        updateGroupList(state, tableData) {
            state.groupData.splice(0, state.groupData.length, ...tableData.groupData);
            state.groupListTotal = tableData.groupListTotal;
        },
        updateRoleList(state, tableData) {
            state.roleData.splice(0, state.roleData.length, ...tableData.roleData);
            state.roleListTotal = tableData.roleListTotal;
        },
        updateGroupTagData(state, datas) {
            state.groupTagDatas.splice(0, state.groupTagDatas.length, ...datas);
            state.searchGroupTagDatas.splice(0, state.searchGroupTagDatas.length, ...datas);
        },
        searchGroupTagScenes(state, data) {
            let searchDatas = [];
            state.searchGroupTagDatas.forEach(item => {
                if (item.label.indexOf(data.field) != -1) {
                    searchDatas.push(item);
                }
            });
            data.field != "" ? (state.groupTagDatas = searchDatas) : (state.groupTagDatas = state.searchGroupTagDatas);
        },
        initGroupQuerySet(state) {
            state.querySetting = {};
        }
    },
    actions: {
        initGroupOption(context) {
            queryGroupOptions().then(function(options) {
                context.commit("updateGroupOption", options);
            });
        },
        initRoleOption(context) {
            queryRoleOptions().then(function(options) {
                context.commit("updateRoleOption", options);
            });
        },
        queryAccountList(context, param) {
            param && context.commit("updateParamSetting", param);

            queryAccountData(context.state.querySetting).then(function(tableData) {
                context.commit("updateAccountList", tableData);
            });
        },
        deleteAccountData(context, param) {
            deleteAccountData(param).then(function() {
                context.dispatch("queryAccountList");
            });
        },
        updateAccountStatus(context, param) {
            updateAccountStatus(param).then(function() {
                context.dispatch("queryAccountList");
            });
        },
        queryGroupList(context, param) {
            param && context.commit("updateParamSetting", param);

            queryGroupData(context.state.querySetting).then(function(tableData) {
                context.commit("updateGroupList", tableData);
            });
        },
        deleteGroupData(context, param) {
            deleteGroupData(param).then(function() {
                context.dispatch("queryGroupList");
            });
        },
        updateGroupStatus(context, param) {
            updateGroupStatus(param).then(function() {
                context.dispatch("queryGroupList");
            });
        },
        queryRoleList(context, param) {
            param && context.commit("updateParamSetting", param);
            queryRoleData(context.state.querySetting).then(function(tableData) {
                context.commit("updateRoleList", tableData);
            });
        },
        deleteRoleData(context, param) {
            deleteRoleData(param).then(function() {
                context.dispatch("queryRoleList");
            });
        },
        updateRoleStatus(context, param) {
            updateRoleStatus(param).then(function() {
                context.dispatch("queryRoleList");
            });
        },
        getGroupTagTreesData(context) {
            getTagTreesData().then(function(treeData) {
                const tagData = sceneTree2Selector(treeData);
                context.commit("updateGroupTagData", tagData);
            });
        }
    }
};
